module.exports = __webpack_public_path__ + "static/media/copy.41e0632d.svg";